export const BACK_COVER_X = -0.21
export const DEFAULT_X = 0
export const ZOOMED_IN_Z = 0.3
export const ZOOMED_OUT_Z_MOBILE = 0.5
export const ZOOMED_OUT_Z_DESKTOP = 0.3
export const BOOK_CLOSED_Z_DESKTOP = 0.3
export const BOOK_CLOSED_Y_MOBILE = -0.012
export const BOOK_CLOSED_Y_DESKTOP = -0.008
export const HIGHLIGHTED_PAGE_Z = 0.25
export const CAPTION_EDIT_Z = 0.15
export const CAPTION_EDIT_Z_LONG_TEXT = 0.19
export const DESKTOP_CAPTION_EDIT_Z = 0.18
export const BOOK_MAX_ZOOM = 2

export const BOOK_COVER_RENDERED_SIZE = 0.201
export const OPEN_BOOK_RENDERED_SIZE = 0.41

export const CLOSE_BOOK_DEPTH = 0.011051
export const OPEN_BOOK_DEPTH = 0.001949

export const COVER_FLIP_SPEED = 0.3
export const PAGE_FLIP_SPEED = 0.6
export const CURVE_SPEED = 0.7

// We need to load the texture before starting the animation for pages outside the window
export const GO_TO_PAGE_DELAY = 1000
export const BACK_COVER_OPEN_DELAY = 500

export const PAGE_GAP = 0.00002

export const MODEL_PATH =
  'https://res.cloudinary.com/mixtiles/image/upload/v1712583924/3D/models/book/01_book_anim_stretchUV.glb'

export const RIGHT_PAGE_POSITION = 0
export const LEFT_PAGE_POSITION = -0.207

export const SWIPE_MIN_DISTANCE = 40

export const PageModelParams = {
  actionName: 'page',
  frontPageNodeName: 'page_1',
  backPageNodeName: 'page_2',
}

export const CoverModelParams = {
  frontCoverNodeName: 'cover_1',
  backCoverNodeName: 'cover_2',
  whitePaperNodeName: 'cover_3',
  actionName: 'open',
}

export const ActionNames = {
  OPEN_FRONT: 'front_open',
  CLOSE_FRONT: 'front_close',
  OPEN_BACK: 'back_open',
  CLOSE_BACK: 'back_close',
  PAGE_LEFT: 'p_to_left',
  PAGE_RIGHT: 'p_to_right',
  CURVE_RIGHT: 'p_add_right',
  CURVE_LEFT: 'p_add_left',
}
